import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as rmd from 'material-ui';
import cx from 'classnames';
import { Link } from 'react-router';
import auth from '../auth';
import _ from 'lodash';
import { indigo500, grey300, grey600, cyan500 } from 'material-ui/styles/colors';
import IconShare from 'material-ui/svg-icons/social/share';
import IconHome from 'material-ui/svg-icons/action/home';
import IconImages from 'material-ui/svg-icons/image/collections';
import IconPallete from 'material-ui/svg-icons/image/palette';
import IconStyle from 'material-ui/svg-icons/image/style';
import IconCode from 'material-ui/svg-icons/action/code';
import IconCampaigns from 'material-ui/svg-icons/places/all-inclusive';
import IconPacks from 'material-ui/svg-icons/action/view-week';
import IconUsersPacks from 'material-ui/svg-icons/action/assignment-ind';
import IconWidgetsDashboard from 'material-ui/svg-icons/action/view-quilt';
import IconCommonI18Dashboard from 'material-ui/svg-icons/action/language';
import IconSettings from 'material-ui/svg-icons/action/settings';
import IconMessage from 'material-ui/svg-icons/communication/message';
import IconFindInPage from 'material-ui/svg-icons/action/find-in-page';
import IconFindAndReplace from 'material-ui/svg-icons/action/find-replace';
import IconPictureInPicture from 'material-ui/svg-icons/action/picture-in-picture';
import IconViewModule from 'material-ui/svg-icons/action/view-module';
import IconButton from 'material-ui/IconButton';
import IconTVSchedule from 'material-ui/svg-icons/notification/live-tv';
import styled from 'styled-components';
import IconWidgets from 'material-ui/svg-icons/action/reorder';

const MenuStickedMinimized = styled.div`
    background-color: #fff;
    box-sizing: border-box;
    border-right: 1px solid ${grey300};
    height: 100%;
    width: 64px;
    position: fixed;
    z-index: 1300;
    left: 0px;
    top: 0px;
    padding: 64px 0 0 0;
    transition: all 0.4s ease-out;
`;

const UL = styled.ul`
    position: relative;
    padding: 0;
    margin: 0;
    list-style: none;
    border-bottom: 1px solid ${grey300};

    &.active-section {
        &:after {
            content: '';
            display: block;
            width: 3px;
            height: 100%;
            background: ${cyan500};
            position: absolute;
            top: 0;
            left: 0;
            transition: all 0.2s ease;
        }
    }

    &:last-child {
        border-bottom: none;
    }
`;

const Item = styled.li`
    max-height: 48px;

    &.active,
    &:hover {
        background-color: ${indigo500};
        transition: all 0.3s ease-out;
        svg {
            fill: #fff !important;
        }
        div {
            color: #fff;
        }
    }
`;

const LI = styled.li`
    max-height: 48px;
    text-align: center;

    &.active,
    &:hover {
        background-color: ${indigo500};
        transition: all 0.3s ease-out;
        svg {
            fill: #fff !important;
        }
    }
`;

const MENU_ITEMS = [
    {
        name: 'Home',
        link: '/home',
        icon: <IconHome />,
        section: 'home',
    },
    {
        name: 'Social Messages',
        link: '/messages',
        icon: <IconMessage />,
        section: 'others',
    },
    {
        name: 'Widgets',
        link: '/widgets/pick',
        icon: <IconCode />,
        section: 'html_js_widgets',
    },
    {
        name: 'Themes',
        link: '/themes',
        icon: <IconPallete />,
        section: 'html_js_widgets',
    },
    {
        name: 'Widget Overview',
        link: '/v2/widgets',
        external: true,
        icon: <IconWidgets />,
        section: 'social_media_images',
    },
    {
        name: 'SM Browser',
        link: '/sm/browser/football/tournaments/46',
        parttern: '/sm/browser/football/tournaments',
        icon: <IconShare />,
        section: 'social_media_images',
    },
    {
        name: 'SM Widgets',
        link: '/sm/browser/post',
        icon: <IconCode />,
        section: 'social_media_images',
    },
    {
        name: 'SM Templates',
        link: '/sm/templates',
        icon: <IconStyle />,

        section: 'social_media_images',
    },

    {
        name: 'Campaigns',
        link: '/campaigns',
        icon: <IconCampaigns />,
        // icon: ({
        //     /*<Badge
        //         badgeContent={10}
        //         secondary
        //         badgeStyle={{ top: '2px', right: '-6px', width: '18px', height: '18px', fontSize: '9px' }}
        //         style={{ padding: 0 }}
        //     >
        //         <IconButton
        //             iconStyle={{ fill: grey600 }}
        //             touch
        //             tooltipStyles={{ top: '65%', left: '100%' }}
        //             tooltipPosition="top-right"
        //             tooltip="Campaigns"
        //         >
        //             <IconCampaigns />
        //         </IconButton>
        //     </Badge>*/
        // },
        // (

        // )),
        section: 'scheduled_social_posting',
    },
    {
        name: 'TV Schedule',
        link: '/tv-program',
        icon: <IconTVSchedule />,
        section: 'tv_program',
    },
    {
        name: 'Grid Maker Tool',
        link: '/grid-maker-tool',
        icon: <IconPictureInPicture />,
        section: 'grid_maker_tool',
    },
    {
        name: 'Images',
        link: '/media/uploads',
        icon: <IconImages />,
        section: 'others',
    },
    {
        name: 'Account Settings',
        link: '/account',
        icon: <IconSettings />,
        section: 'others',
    },
    // {
    //     name: 'Ids Finder',
    //     link: '/ids-finder/soccer/tournaments',
    //     icon: <IconFindInPage />,
    //     section: 'others',
    // },
    // {
    //     name: 'Provider Ids',
    //     link: '/mapping/nordic',
    //     icon: <IconFindAndReplace />,
    //     section: 'others',
    // },
    // {
    //     name: 'Player Performance Index',
    //     link: '/ppi',
    //     icon: <IconViewModule />,
    //     section: 'others',
    // },
    {
        name: 'Accounts',
        link: '/admin/accounts',
        icon: <IconUsersPacks />,
        section: 'administration',
    },
    {
        name: 'Packs',
        link: '/admin/packs',
        icon: <IconPacks />,
        section: 'administration',
    },
    {
        name: 'Users Packs',
        link: '/admin/users-packs',
        icon: <IconUsersPacks />,
        section: 'administration',
    },
    {
        name: 'Widgets Dashboard',
        link: '/admin/widgets-dashboard',
        icon: <IconWidgetsDashboard />,
        section: 'administration',
    },
    {
        name: 'i18 Dashboard',
        link: '/admin/common-i18-dashboard',
        icon: <IconCommonI18Dashboard />,
        section: 'administration',
    },
];

const getMenuSections = ({
    isHTMLAllowed,
    isSMAllowed,
    isCampaignsAllowed,
    hasAdminRights,
    isTVAllowed,
    isGridMakerToolAllowed,
}) => {
    const sections = [
        {
            name: 'home',
            allowed: true,
        },
        {
            name: 'html_js_widgets',
            allowed: isHTMLAllowed,
            menuHeading: 'HTML/JS Widgets',
        },
        {
            name: 'social_media_images',
            allowed: isSMAllowed,
            menuHeading: 'Social Media Images',
        },
        {
            name: 'tv_program',
            allowed: isTVAllowed,
            menuHeading: 'TV',
        },
        {
            name: 'grid_maker_tool',
            allowed: isGridMakerToolAllowed,
            menuHeading: 'Grid Maker Tool',
        },
        {
            name: 'scheduled_social_posting',
            allowed: isSMAllowed && isCampaignsAllowed,
            menuHeading: 'Scheduled Social Posting',
        },
        {
            name: 'others',
            allowed: true,
            menuHeading: false,
        },
        {
            name: 'administration',
            allowed: hasAdminRights,
            menuHeading: 'Administration',
        },
    ];

    return sections;
};

class MainMenu extends Component {
    static contextTypes = {
        user: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    addActiveClass(linkTo) {
        const pathname = this.context.router.location.pathname;

        return linkTo === pathname ? 'active' : '';
    }

    render() {
        const { drawerOpen, handleDrawerClose, onRequestChange } = this.props;

        const user = this.context.user;

        const isHTMLAllowed = user && _.get(user, 'permissions.htmlWidgets', false);
        const isSMAllowed = user && _.get(user, 'permissions.smWidgets', false);
        const isCampaignsAllowed = user && _.get(user, 'permissions.campaigns', false);
        const isTVAllowed = user && _.get(user, 'permissions.tvSchedule', false);
        const isGridMakerToolAllowed = user && _.get(user, 'permissions.gridMakerTool', false);

        const hasAdminRights = auth.hasAdminRights();

        const sections = getMenuSections({
            isHTMLAllowed,
            isSMAllowed,
            isCampaignsAllowed,
            hasAdminRights,
            isTVAllowed,
            isGridMakerToolAllowed,
        });
        const pathname = this.context.router.location.pathname;
        return (
            <rmd.Drawer
                open={drawerOpen}
                docked
                zDepth={1}
                onRequestChange={onRequestChange()}
                containerClassName="drawer"
            >
                <div className="drawer-top" />

                {sections.map(section => {
                    const allowed = section.allowed || hasAdminRights;

                    if (!allowed) {
                        return;
                    }
                    return (
                        <UL key={section.name}>
                            {section.menuHeading && <li className="menu-heading">{section.menuHeading}</li>}

                            {MENU_ITEMS.map(item => {
                                //for grouping menu items into UL
                                if (section.name !== item.section) return;

                                return (
                                    <Item
                                        key={item.name}
                                        className={cx({
                                            active: pathname.indexOf(item.parttern || item.parttern) === 0,
                                        })}
                                        onClick={e => {
                                            if (item.external) {
                                                e.stopPropagation();
                                                window.location.href = item.link;
                                            }
                                        }}
                                    >
                                        <Link to={item.link}>
                                            <rmd.MenuItem leftIcon={item.icon} onTouchTap={handleDrawerClose('home')}>
                                                {item.name}
                                            </rmd.MenuItem>
                                        </Link>
                                    </Item>
                                );
                            })}
                        </UL>
                    );
                })}
            </rmd.Drawer>
        );
    }
}

class MainMenuMinimized extends Component {
    static contextTypes = {
        user: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    render() {
        const { drawerOpen } = this.props;
        const pathname = this.context.router.location.pathname;
        const user = this.context.user;
        const isHTMLAllowed = user && _.get(user, 'permissions.htmlWidgets', false);
        const isSMAllowed = user && _.get(user, 'permissions.smWidgets', false);
        const isCampaignsAllowed = user && _.get(user, 'permissions.campaigns', false);
        const isTVAllowed = user && _.get(user, 'permissions.tvSchedule', false);
        const isGridMakerToolAllowed = user && _.get(user, 'permissions.gridMakerTool', false);

        const hasAdminRights = auth.hasAdminRights();

        const sections = getMenuSections({
            isHTMLAllowed,
            isSMAllowed,
            isCampaignsAllowed,
            hasAdminRights,
            isTVAllowed,
            isGridMakerToolAllowed,
        });

        const activeMenuItem = _.find(MENU_ITEMS, item => pathname.indexOf(item.parttern || item.parttern) === 0);

        const menuStyles = {
            transform: drawerOpen ? 'translateX(-100%)' : 'translateX(0)',
        };

        return (
            <MenuStickedMinimized style={menuStyles}>
                {sections.map(section => {
                    const allowed = section.allowed || hasAdminRights;
                    if (!allowed) return;
                    return (
                        <UL
                            key={section.name}
                            className={cx({
                                'active-section': activeMenuItem && section.name === activeMenuItem.section,
                            })}
                        >
                            {MENU_ITEMS.map(item => {
                                //for grouping menu items into UL
                                if (section.name !== item.section) return;

                                return (
                                    <LI
                                        key={item.link}
                                        className={cx({
                                            active: pathname.indexOf(item.parttern || item.parttern) === 0,
                                        })}
                                    >
                                        <Link
                                            to={item.link}
                                            onClick={e => {
                                                if (item.external) {
                                                    e.stopPropagation();
                                                    window.location.href = item.link;
                                                }
                                            }}
                                        >
                                            <IconButton
                                                iconStyle={{ fill: grey600 }}
                                                tooltipStyles={{
                                                    left: 60,
                                                    top: 0,
                                                    zIndex: 100000,
                                                    pointerEvents: 'none',
                                                }}
                                                tooltip={item.name}
                                            >
                                                {item.icon}
                                            </IconButton>
                                        </Link>
                                    </LI>
                                );
                            })}
                        </UL>
                    );
                })}
            </MenuStickedMinimized>
        );
    }
}

export default MainMenu;
export { MainMenu, MainMenuMinimized };



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/AppMenu.js
 **/